import { Lens } from 'monocle-ts';
import { AxiosResponse } from 'axios';

export const getDataFromAxios = Lens.fromProp<AxiosResponse>()('data');
